import React from 'react'
import PropTypes from 'prop-types'
// import Raven from 'raven-js'
// import canUseDom from '@argos/utils/esnext/canUseDom'
import Alert from '@argos/alert'

class ErrorBoundary extends React.Component {
  static defaultProps = {
    retries: 0,
    showErrorMsg: false,
    errorMsg: "Oops, something's gone wrong. We're working hard to fix it... please try again later.",
    alertProps: {
      backgroundColor: 'white',
      borderColor: 'dark-navy',
      textColor: 'dark-navy',
    },
    callbackFunction: () => {},
  }

  static propTypes = {
    children: PropTypes.object,
    retries: PropTypes.number,
    showErrorMsg: PropTypes.bool,
    errorMsg: PropTypes.string,
    FallbackComponent: PropTypes.element,
    alertProps: PropTypes.object,
    callbackFunction: PropTypes.func,
  }

  constructor(props) {
    super(props)
    this.state = {
      hasError: false,
      errorCount: 0,
    }
  }

  componentDidCatch() {
    if (this.props.retries >= 1) {
      this.setState((oldState) => ({ errorCount: oldState.errorCount + 1 }))
    } else {
      this.setState({ hasError: true })
      // TODO: Bring Raven JS inhouse, as they do not support proper exports
      //  componentDidCatch (error, info) {
      // if(canUseDom()) Raven.captureException(error, { extra: info })
      if (typeof this.props.callbackFunction === 'function') this.props.callbackFunction()
    }
  }

  render() {
    const { children, retries, showErrorMsg, errorMsg, FallbackComponent, alertProps } = this.props

    if ((retries >= 1 && this.state.errorCount > retries) || this.state.hasError) {
      if (showErrorMsg) return <Alert {...alertProps}>{errorMsg}</Alert>
      if (FallbackComponent) return FallbackComponent
      return null
    }
    return children
  }
}

export default ErrorBoundary
